export default __webpack_public_path__ + "static/adam-bdd2b7c760c51caeb9a4b1aaa3f98d20.png";